import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const TableToolbar = ({ className, children }) => {
    const wrapperClassNames = classNames('table-toolbar', className && className);
    return _jsx("div", Object.assign({ className: wrapperClassNames }, { children: children }));
};
TableToolbar.defaultProps = {};
TableToolbar.propTypes = {
    className: PropTypes.string,
};
export default TableToolbar;
